import { toolbar_colors } from "../Components/ReactFlowShapes/ReactFlowShapes.constants";


export const getRandomColorFromStringArray = (currentColor: string): string => {
    const randomIndex = Math.floor(Math.random() * toolbar_colors.length);
    if (currentColor === toolbar_colors[randomIndex]) {
        getRandomColorFromStringArray(currentColor)
    }
    return toolbar_colors[randomIndex];
}